import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { USERS_IMPORTER_FEATURE_KEY } from './keys';
import { usersImporterReducer } from './reducers/users-importer.reducer';
import { UsersImporterEffects } from './effects/users-importer.effects';

export function provideUsersImporterStore(): EnvironmentProviders[] {
    return [provideState(USERS_IMPORTER_FEATURE_KEY, usersImporterReducer), provideEffects(UsersImporterEffects)];
}
